import { AbstractTeaser } from "./AbstractTeaser";
import { TeaserTextsVO } from "./TeaserTextsVO";

export class TeaserVO {
    public teaserInstance: AbstractTeaser;
    public teaserTextsVO: TeaserTextsVO;
}
